export default __webpack_public_path__ + "static/media/img-0466-montenegro-premium-face.614e17ed.png";